var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconProducts = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14.484,
    height: 14,
    viewBox: "0 0 14.484 14",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1237",
    "data-name": "Group 1237",
    transform: "translate(-15 -313)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1020",
    "data-name": "Group 1020",
    transform: "translate(-973.516 -174)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "menu_copy",
    "data-name": "menu copy",
    transform: "translate(988.516 486.999)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2460",
    "data-name": "Path 2460",
    d: "M.112,13.969A.231.231,0,0,0,.229,14a.226.226,0,0,0,.1-.025l4.61-2.384L9.4,13.975a.219.219,0,0,0,.2,0l4.756-2.437a.225.225,0,0,0,.126-.194V.219a.228.228,0,0,0-.329-.194L9.505,2.409,5.047.063a.219.219,0,0,0-.2,0L.127,2.461A.226.226,0,0,0,0,2.655V13.782a.225.225,0,0,0,.112.187Zm9.159-.563-4.12-2.194V.617l4.12,2.159Zm4.776-2.194L9.708,13.435V2.8L14.047.576ZM.437,2.789,4.714.615v10.6L.437,13.423Zm0,0",
    transform: "translate(0 0)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2461",
    "data-name": "Path 2461",
    d: "M332.166,105.33a.218.218,0,0,0,.1-.024l2.651-1.36a.219.219,0,1,0-.2-.389l-2.651,1.36a.218.218,0,0,0,.1.413Zm0,0",
    transform: "translate(-321.585 -100.299)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2462",
    "data-name": "Path 2462",
    d: "M332.162,154.674a.218.218,0,0,0,.1-.024l2.651-1.36a.219.219,0,1,0-.2-.389l-2.651,1.36a.219.219,0,0,0,.1.413Zm0,0",
    transform: "translate(-321.582 -148.103)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2463",
    "data-name": "Path 2463",
    d: "M334.7,202.249l-2.651,1.36a.219.219,0,1,0,.2.389l2.651-1.36a.218.218,0,1,0-.2-.389Zm0,0",
    transform: "translate(-321.563 -195.911)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2464",
    "data-name": "Path 2464",
    d: "M35.258,222.991l-2.651,1.36a.219.219,0,1,0,.2.389l2.651-1.36a.219.219,0,1,0-.2-.389Zm0,0",
    transform: "translate(-31.473 -216.006)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2465",
    "data-name": "Path 2465",
    d: "M35.258,272.339l-2.651,1.36a.219.219,0,1,0,.2.389l2.651-1.36a.218.218,0,1,0-.2-.389Zm0,0",
    transform: "translate(-31.473 -263.814)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2466",
    "data-name": "Path 2466",
    d: "M188.546,158.436l-2.452-1.291a.219.219,0,0,0-.2.387l2.452,1.29a.218.218,0,1,0,.2-.387Zm0,0",
    transform: "translate(-179.976 -152.216)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2467",
    "data-name": "Path 2467",
    d: "M185.837,98.285l2.452,1.29a.218.218,0,1,0,.2-.387L186.04,97.9a.219.219,0,0,0-.2.387Zm0,0",
    transform: "translate(-179.923 -94.817)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2468",
    "data-name": "Path 2468",
    d: "M35.954,84.837a.212.212,0,0,0-.21-.008L33.1,86.19a.21.21,0,0,0-.109.194v1.849a.212.212,0,0,0,.1.186.205.205,0,0,0,.11.032.212.212,0,0,0,.1-.024l2.643-1.36a.211.211,0,0,0,.111-.194V85.024A.212.212,0,0,0,35.954,84.837Zm-.339,1.9L33.43,87.875V86.518l2.185-1.136Zm0,0",
    transform: "translate(-31.963 -82.158)",
    fill: "#173a6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2469",
    "data-name": "Path 2469",
    d: "M188.757,227.5l-2.45-1.291a.208.208,0,0,0-.209.006.214.214,0,0,0-.1.187v2.157a.214.214,0,0,0,.112.193l2.45,1.291a.215.215,0,0,0,.1.025.2.2,0,0,0,.108-.031.214.214,0,0,0,.1-.187v-2.157A.214.214,0,0,0,188.757,227.5Zm-.325,1.988-2-1.06v-1.663l2,1.06Zm0,0",
    transform: "translate(-180.191 -219.12)",
    fill: "#173a6d"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconProducts, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_products.763d7da0.svg";
export { ForwardRef as ReactComponent };